import { render, staticRenderFns } from "./card-basic-b1.vue?vue&type=template&id=2bfaf177&scoped=true&"
import script from "./card-basic-b1.vue?vue&type=script&lang=js&"
export * from "./card-basic-b1.vue?vue&type=script&lang=js&"
import style0 from "./card-basic-b1.vue?vue&type=style&index=0&id=2bfaf177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfaf177",
  null
  
)

export default component.exports